export const ownCollectNotFinishedOptions = [
  {
    label: "Coletador não atendido",
    value: 1
  },
  {
    label: "Cliente desconhecido no local",
    value: 2
  },
  {
    label: "Cliente mudou-se",
    value: 3
  },
  {
    label: "Cliente recusou-se a entregar a coleta",
    value: 4
  },
  {
    label: "Cliente não apresentou documento exigido",
    value: 5
  },
  {
    label: "Empresa sem expediente",
    value: 6
  },
  {
    label: "Endereço incorreto",
    value: 7
  },
  {
    label: "Logradouro com numeração irregular",
    value: 8
  },
  {
    label: "O coletador não finalizou a coleta",
    value: 14
  },
  {
    label: "Área de risco",
    value: 15
  },
]

const OwnCollectStatusNotFinishedOptions = [
  {
    label: "Coleta não foi realizada",
    value: 6
  },
  {
    label: "Não foi possível realizar a coleta",
    value: 13
  },
]

export const OwnCollectStatusOptions = [...OwnCollectStatusNotFinishedOptions.map(s => s.value), 10, 5]